import { Injectable, inject } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class CustomMatPaginatorIntl extends MatPaginatorIntl {
  private translate = inject(TranslateService);

  constructor() {
    super();
    this.translate.onLangChange.subscribe(() => {
      this.updateLabels();
    });
    this.translate.onDefaultLangChange.subscribe(() => {
      this.updateLabels();
    });
    this.updateLabels();
  }

  updateLabels(): void {
    this.itemsPerPageLabel = this.translate.instant('paginator.items_per_page') || 'Items per pagina:';
    this.nextPageLabel = this.translate.instant('paginator.next_page') || 'Volgende pagina';
    this.previousPageLabel = this.translate.instant('paginator.previous_page') || 'Vorige pagina';
    this.firstPageLabel = this.translate.instant('paginator.first_page') || 'Eerste pagina';
    this.lastPageLabel = this.translate.instant('paginator.last_page') || 'Laatste pagina';
    this.changes.next();
  }

  override getRangeLabel = (page: number, pageSize: number, length: number): string => {
    if (length === 0 || pageSize === 0) {
      const ofLabel = this.translate.instant('paginator.of') || 'van';
      return `0 ${ofLabel} ${length}`;
    }
    length = Math.max(length, 0);
    const startIndex = page * pageSize;
    const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;
    const ofLabel = this.translate.instant('paginator.of') || 'van';
    return `${startIndex + 1} – ${endIndex} ${ofLabel} ${length}`;
  };
}
